import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import add_driver from "../../../../assets/images/add_driver.png";
import { Step, StepLabel, Stepper } from '@mui/material';
import { faCircleXmark, faArrowLeft, faArrowRight, faSave, faDownload } from '@fortawesome/free-solid-svg-icons';
import trash from "../../../../assets/images/trash.png";
import red_x from "../../../../assets/images/icon_svg/red_close.svg";
import remove_driver from "../../../../assets/images/remove_driver.png";
import { Row, Col, Modal, Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { withRFSToken } from '../../../../Services/axios.js';
import bin from '../../../../assets/images/bin.png';
import info from '../../../../assets/images/icon_svg/icon_info.svg';
import green_check from '../../../../assets/images/green_check.png';
import { SLOTPLANNINGAVAILABLESLOT, GETOWNERCODE } from '../../../../Utils/conts.js';
import "../../../../assets/css/Trucker/Trucker.css";
import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CallApi, CommonModal } from '../../../../Components/common/CommonFunctions.js';


/* ─── Pure helpers — hoisted outside component to prevent recreation on each render ─── */

const EMPTY_AVAILABLE_SLOTS = { past: [], present: null, future: [], message: "" };

const TD_REQUIRED_FIELDS = [
    'driver1_first_name',
    'driver1_last_name',
    'trip_status',
    'trailer_license_plate',
    'truck_license_plate',
];

const defaultSequence = (seqIndex = 0) => ({
    id: Date.now() + Math.random(),
    flight_prefix: "",
    flight_no: "",
    truck_date: "",
    intact_loose: "",
    loading_sequence: seqIndex + 1,
});

const defaultLocation = () => ({
    staion_name: "AMS",
    staion_id: "AMS",
    handler_name: "",
    handler_id: "",
    trip_status: "",
    sequences: [defaultSequence(0)],
});

const buildTruckNosFromSequences = (sequences = []) => sequences.filter(seq => seq.flight_prefix && seq.flight_no).map(seq => `${seq.flight_prefix}${seq.flight_no}`).join(", ");

const getIntactLooseMeta = (sequences = []) => {
    if (!sequences.length) return { label: null, code: null };
    const allIntact = sequences.every(seq => seq.intact_loose === "Intact");
    const label = allIntact ? "Intact" : "Loose";
    return { label, code: label === "Loose" ? 1 : 2 };
};

const formatTime = (datetime) =>
    new Date(datetime).toLocaleTimeString('en-IN', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    });

const isSelectedSlot = (item, slotType, slot) => {
    if (!item.selected_slot_key) return false;
    return (
        item.selected_slot_type === slotType &&
        item.selected_slot_key === `${slot.door_id}_${slot.start_time}`
    );
};

/* ─── Component ──────────────────────────────────────────────────────────────── */

const TripEditModal = ({ rowData, setRowData, onSuccess, mode = null, setMode, onClose }) => {
    const isMounted = useRef(false);
    const initialState = useRef(true);
    const gridRefs = useRef({});

    const [showModalRequestSlot, setShowModalRequestSlot] = useState(false);
    const [getDestination, setGetDestination] = useState([]);
    const [driver2, setDriver2] = useState(false);
    const [orderDetailsModal, setOrderDetailsModal] = useState(false);
    const [gridSelectData, setGridSelectData] = useState([]);
    const [isLoadingod, setIsLoadingOd] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const [tripEditData, setTripEditData] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [initialFormData, setInitialFormData] = useState({});
    const [deletedTodIds, setDeletedTodIds] = useState([]);
    const [handlerOptionsByLocation, setHandlerOptionsByLocation] = useState({});

    const steps = useMemo(() => [
        { id: 0, title: "Trip Details", sub_title: "Enter vehicle and driver information for this trip." },
        { id: 1, title: "Truck Order Details", sub_title: "Enter the handler locations and assign the truck orders involved in this trip." },
        { id: 2, title: "Slot Booking", sub_title: "Indicate planning time to book a timeslot at the handler." },
    ], []);

    const [todFormData, setTodFormData] = useState([defaultLocation()]);
    const [tdFormData, setTdFormData] = useState({
        driver1_first_name: "",
        driver1_last_name: "",
        license_plate: "",
        side_loading: "",
        trip_status: "",
        orderDetails: [{ order_no: '', truck_no: '', truck_date: '' }],
    });
    const [sbFormData, setSbFormData] = useState({ loading: [], unloading: [] });
    const [activeStep, setActiveStep] = useState();

    /* ── Core state mutators ─────────────────────────────────────────────────── */

    const syncSbFromTod = useCallback((todData) => {
        let allData;
        setSbFormData(prev => {
            const newLoading = [];
            const newUnloading = [];
            todData.forEach(loc => {
                if (!loc.trip_status) return;
                const sequences = (loc.sequences || []).map(seq => ({
                    flight_prefix: seq.flight_prefix,
                    flight_no: seq.flight_no,
                    truck_date: seq.truck_date,
                    intact_loose: seq.intact_loose,
                    loading_sequence: seq.loading_sequence,
                }));
                const existing =
                    prev.loading.find(l => l.station === loc.staion_name && l.warehouse_id === loc.handler_id) ||
                    prev.unloading.find(u => u.station === loc.staion_name && u.warehouse_id === loc.handler_id);
                const baseObj = {
                    id: existing?.id ?? null,
                    station: loc.staion_name,
                    station_id: loc.staion_id,
                    handler_org_id: loc.handler_org_id,
                    handler_name: loc.handler_name,
                    warehouse_id: loc.handler_id || null,
                    date: existing?.date ?? null,
                    planned_date_time: existing?.planned_date_time ?? null,
                    request_booking_slot: existing?.request_booking_slot ?? null,
                    slot: existing?.slot ?? null,
                    availableSlots: existing?.availableSlots ?? { ...EMPTY_AVAILABLE_SLOTS },
                    sequences,
                    truckNos: buildTruckNosFromSequences(sequences),
                };
                if (loc.trip_status === "L") newLoading.push(baseObj);
                if (loc.trip_status === "U") newUnloading.push(baseObj);
            });
            allData = { loading: newLoading, unloading: newUnloading };
            return allData;
        });
        if (initialState.current && todData?.length > 0) {
            setInitialFormData({ todFormData: todData, sbFormData: allData });
            initialState.current = false;
        }
    }, []);

    const addLocation = useCallback(() => {
        setTodFormData(prev => {
            const updated = [...prev, defaultLocation()];
            syncSbFromTod(updated);
            return updated;
        });
    }, [syncSbFromTod]);

    const deleteLocation = useCallback((locationIndex, deletedId) => {
        setTodFormData(prev => {
            const updated = prev.filter((_, i) => i !== locationIndex);
            syncSbFromTod(updated);
            return updated;
        });
        setDeletedTodIds(prev => [...prev, deletedId]);
    }, [syncSbFromTod]);

    const addSequence = useCallback((locationIndex) => {
        setTodFormData(prev => {
            const updated = [...prev];
            const sequences = [...updated[locationIndex].sequences];
            sequences.push(defaultSequence(sequences.length));
            updated[locationIndex] = { ...updated[locationIndex], sequences };
            syncSbFromTod(updated);
            return updated;
        });
    }, [syncSbFromTod]);

    const removeSequence = useCallback((locationIndex, seqIndex) => {
        setTodFormData(prev => {
            const updated = [...prev];
            updated[locationIndex] = {
                ...updated[locationIndex],
                sequences: updated[locationIndex].sequences.filter((_, i) => i !== seqIndex),
            };
            syncSbFromTod(updated);
            return updated;
        });
    }, [syncSbFromTod]);

    const updateLocationField = useCallback((locationIndex, name, value) => {
        setTodFormData(prev => {
            const updated = [...prev];
            updated[locationIndex] = { ...updated[locationIndex], [name]: value };
            syncSbFromTod(updated);
            return updated;
        });
    }, [syncSbFromTod]);

    /** Batch-update multiple fields on a single location in one render cycle. */
    const updateLocationFields = useCallback((locationIndex, fields) => {
        setTodFormData(prev => {
            const updated = [...prev];
            updated[locationIndex] = { ...updated[locationIndex], ...fields };
            syncSbFromTod(updated);
            return updated;
        });
    }, [syncSbFromTod]);

    const updateSequenceField = useCallback((locationIndex, seqIndex, name, value) => {
        setTodFormData(prev => {
            const updated = [...prev];
            const sequences = [...updated[locationIndex].sequences];
            sequences[seqIndex] = { ...sequences[seqIndex], [name]: value };
            updated[locationIndex] = { ...updated[locationIndex], sequences };
            syncSbFromTod(updated);
            return updated;
        });
    }, [syncSbFromTod]);

    const changeSequenceOrder = useCallback((locationIndex, fromIndex, toIndex) => {
        if (fromIndex === toIndex) return;
        setTodFormData(prev => {
            const updated = [...prev];
            const sequences = [...updated[locationIndex].sequences];
            const [moved] = sequences.splice(fromIndex, 1);
            sequences.splice(toIndex, 0, moved);
            updated[locationIndex] = {
                ...updated[locationIndex],
                sequences: sequences.map((seq, i) => ({ ...seq, loading_sequence: i + 1 })),
            };
            syncSbFromTod(updated);
            return updated;
        });
    }, [syncSbFromTod]);

    const resetForm = useCallback(() => {
        setTodFormData([defaultLocation()]);
        setTdFormData({
            driver1_first_name: "",
            driver1_last_name: "",
            license_plate: "",
            side_loading: "",
            trip_status: "",
            orderDetails: [{ order_no: '', truck_no: '', truck_date: '' }],
        });
        setSbFormData({ loading: [], unloading: [] });
    }, []);

    const handleChange = useCallback((form, event) => {
        const { name, value } = event.target;
        if (form === "td") setTdFormData(prev => ({ ...prev, [name]: value }));
        if (form === "sb") setSbFormData(prev => ({ ...prev, [name]: value }));
        if (form === "tod") setTodFormData(prev => ({ ...prev, [name]: value }));
    }, []);

    /* ── Effects ─────────────────────────────────────────────────────────────── */
    useEffect(() => {
        console.log("deletedTodIds", deletedTodIds)
    }, [deletedTodIds]);

    useEffect(() => {
        if (isMounted.current) return;
        fetchDestination();
        isMounted.current = true;
    }, []);

    useEffect(() => {
        if (mode === 'create') {
            resetForm();
            setShowModalRequestSlot(true);
            return;
        }
        const tripId = rowData?.trip_id || rowData?.id;
        if (tripId) getTripData(tripId);
        setActiveStep(rowData?.typeOf ? 2 : 0);
        fetchOwnerCode();
    }, [rowData, mode]);

    useEffect(() => {
        if (showModalRequestSlot) return;
        setActiveStep(0);
        setGridSelectData([]);
        setTripEditData([]);
        setTdFormData({
            driver1_first_name: "",
            driver1_last_name: "",
            license_plate: "",
            side_loading: "",
            trip_status: "",
            orderDetails: [{ order_no: '', truck_no: '', truck_date: '', cargo_condition: '' }],
        });
        setSbFormData({ loading: [], unloading: [] });
    }, [showModalRequestSlot]);

    useEffect(() => {
        if (sbFormData.loading.warehouse_id && sbFormData.loading.date) {
            availableSlot(sbFormData.loading.date, sbFormData.loading.warehouse_id, 'loading');
        }
    }, [sbFormData.loading.date]);

    useEffect(() => {
        if (sbFormData.unloading.warehouse_id && sbFormData.unloading.date) {
            availableSlot(sbFormData.unloading.date, sbFormData.unloading.warehouse_id, 'unloading');
        }
    }, [sbFormData.unloading.date]);

    useEffect(() => {
        if (activeStep !== 2 || !tdFormData.trip_status) return;
        ['loading', 'unloading'].forEach(type => {
            (sbFormData[type] || []).forEach((item, index) => {
                if (!item.date || !item.warehouse_id) return;

                if (mode !== "create") {
                    const changesBool = compareInitialWithCurrent();
                    // Re-fetch in both cases: changed TOD needs fresh slots,
                    // unchanged TOD still needs slots loaded when returning to this step
                    //availableSlot(item.date, item.warehouse_id, type, index, setSbFormData);
                }
            });
        });
    }, [activeStep]);

    // useEffect(() => {
    //     if (activeStep !== 2 || !tdFormData.trip_status) return;

    //     ['loading', 'unloading'].forEach(type => {
    //         (sbFormData[type] || []).forEach((item, index) => {
    //             if (!item.date || !item.warehouse_id) return;
    //             const changesBool = compareInitialWithCurrent();
    //             if (mode !== "create") {
    //                 if (changesBool === 1) {
    //                     availableSlot(item.date, item.warehouse_id, type, index, setSbFormData);
    //                 } else {
    //                     setSbFormData(prev => {
    //                         const resetSection = (section = []) =>
    //                             section.map(s => ({
    //                                 ...s,
    //                                 availableSlots: { ...EMPTY_AVAILABLE_SLOTS },
    //                                 slot: null,
    //                             }));
    //                         return { loading: resetSection(prev.loading), unloading: resetSection(prev.unloading) };
    //                     });
    //                 }
    //             }
    //         });
    //     });
    // }, [activeStep]);

    useEffect(() => {
        if (!getDestination.length) return;
        setHandlerOptionsByLocation(prev => {
            const updated = { ...prev };
            todFormData.forEach((location, index) => {
                if (location.staion_name && !updated[index]) {
                    updated[index] = fetchHandler(location.staion_id);
                }
            });
            return updated;
        });
    }, [getDestination, todFormData]);

    /* ── API helpers ─────────────────────────────────────────────────────────── */

    const fetchDestination = async () => {
        try {
            const res = await withRFSToken.post('trip-management/get-station-with-warehouses', {});
            const transformedData = res.data.response_data.map(item => ({
                value: item.code,
                label: item.code,
                port_Id: item.port_Id,
                station_users: item.station_users,
            }));
            setGetDestination(transformedData);
            return transformedData;
        } catch (error) {
            console.error('Error fetching destinations:', error);
        }
    };

    const fetchOwnerCode = async () => {
        try {
            const res = await withRFSToken.post(GETOWNERCODE, {});
            const innerData = res.data.response_data;
            setGetOwnerCode(
                innerData
                    ? innerData.map(item => ({ value: item.IATA, label: item.IATA, pref: item.AWB_prefix }))
                    : []
            );
        } catch (error) {
            console.error('Error fetching owner codes:', error);
        }
    };

    const getTripData = async (id) => {
        try {
            const res = await withRFSToken.post('trip-details', { trip_id: id });
            const data = res.data.response_data;

            initialState.current = true;
            setTripEditData(data);
            setGridSelectData(data.orders || []);
            setDriver2(!!data.trip_details.driver2_first_name);
            setTdFormData({
                driver1_first_name: data.trip_details.driver1_first_name ?? "",
                driver1_last_name: data.trip_details.driver1_last_name ?? "",
                driver2_first_name: data.trip_details.driver2_first_name ?? "",
                driver2_last_name: data.trip_details.driver2_last_name ?? "",
                truck_license_plate: data.trip_details.truck_license_plate ?? "",
                trailer_license_plate: data.trip_details.trailer_license_plate ?? "",
                side_loading: data.trip_details.side_loading ?? "",
                trip_status: data.trip_details.trip_status ?? "",
                orderDetails: (data.order_ids || []).map(orderId => ({
                    order_no: orderId,
                    truck_no: "",
                    truck_date: "",
                })),
            });

            const loading = [];
            const unloading = [];
            (data.slot_booking || []).forEach(item => {
                const truckNos = [...new Set(
                    item.order_shippings?.map(os => os.order?.truck_no).filter(Boolean)
                )].join(", ");

                const slotItem = {
                    station: item.station,
                    station_id: item.station_id,
                    handler_org_id: item.handler_org_id,
                    handler_name: item.handler_name,
                    warehouse_id: item.warehouse_id,
                    slots: item.slots[0],
                    id: item.id,
                    planned_date_time: item.planned_date_time,
                    request_booking_slot: item.request_booking_slot,
                    date: item.planned_date_time ? item.planned_date_time.replace(" ", "T") : null,
                    availableSlots: { ...EMPTY_AVAILABLE_SLOTS },
                    truckNos,
                };

                if (item.shipping_type === "L") loading.push(slotItem);
                if (item.shipping_type === "U") unloading.push(slotItem);
            });

            setSbFormData({ loading, unloading });
            syncGridSelection();
            setShowModalRequestSlot(true);
            const todData = (data.truck_order_details || []).map((loc) => {
                const existing =
                    loading.find(l => l.station === loc.staion_name && l.warehouse_id === loc.handler_id) ||
                    unloading.find(u => u.station === loc.staion_name && u.warehouse_id === loc.handler_id);
                return {
                    staion_name: loc.staion_name || "",
                    staion_id: loc.staion_id || "",
                    deleted_id: existing.id,
                    handler_name: loc.handler_name || "",
                    handler_id: loc.handler_id || "",
                    handler_org_id: loc.handler_org_id || "",
                    trip_status: loc.trip_status || "",
                    sequences: (loc.sequences || []).map((seq, index) => ({
                        id: seq.id ?? Date.now() + index,
                        flight_prefix: seq.flight_prefix || "",
                        flight_no: seq.flight_no || "",
                        truck_date: seq.truck_date || "",
                        intact_loose: seq.intact_loose || "",
                        loading_sequence: seq.loading_sequence ?? (index + 1),
                    })),
                };
            });

            // const todData = (data.truck_order_details || []).map(loc => ({
            //     staion_name: loc.staion_name || "",
            //     staion_id: loc.staion_id || "",
            //     handler_name: loc.handler_name || "",
            //     handler_id: loc.handler_id || "",
            //     handler_org_id: loc.handler_org_id || "",
            //     trip_status: loc.trip_status || "",
            //     sequences: (loc.sequences || []).map((seq, index) => ({
            //         id: seq.id ?? Date.now() + index,
            //         flight_prefix: seq.flight_prefix || "",
            //         flight_no: seq.flight_no || "",
            //         truck_date: seq.truck_date || "",
            //         intact_loose: seq.intact_loose || "",
            //         loading_sequence: seq.loading_sequence ?? (index + 1),
            //     })),
            // }));
            setTodFormData(todData.length ? todData : [defaultLocation()]);
            syncSbFromTod(todData);
        } catch (error) {
            console.error('Error fetching trip data:', error);
        }
    };

    const availableSlot = async (date, warehouseId, type, index, setSbFormDataFn = setSbFormData) => {
        if (!date || !warehouseId) return;
        try {
            const [dateVal, timeVal] = date.split("T");
            const sequences = sbFormData[type]?.[index]?.sequences || [];
            const intactLoose = getIntactLooseMeta(sequences);

            const res = await withRFSToken.post(SLOTPLANNINGAVAILABLESLOT, {
                warehouse_id: warehouseId,
                date: dateVal,
                time: timeVal,
                cargo_type_id: intactLoose.code,
                trip_type_id: tdFormData.trip_status === 'Import' ? 4 : 5,
            });

            setSbFormDataFn(prev => {
                const updated = [...prev[type]];
                if (res.data.response_code === 200) {
                    const { recentBefore = [], recentSlots = null, upcomingAfter = [] } = res.data.response_data || {};
                    updated[index] = {
                        ...updated[index],
                        availableSlots: { past: recentBefore, present: recentSlots, future: upcomingAfter, message: "" },
                    };
                } else {
                    updated[index] = {
                        ...updated[index],
                        availableSlots: {
                            past: [], present: null, future: [],
                            message: res.data.response_msg,
                            code: res.data.response_code,
                        },
                    };
                }
                return { ...prev, [type]: updated };
            });
        } catch (err) {
            console.error("Available slot fetch failed", err);
        }
    };

    const handleAddorder = async () => {
        try {
            const res = await withRFSToken.post("trip-management/get-order-shippings", {
                order_ids: gridSelectData.map(item => item.id),
            });
            const innerData = res.data.response_data;
            const loadingArr = [];
            const unloadingArr = [];
            const addTodData = [];

            innerData?.forEach((item, index) => {
                const truckNos = item.truck_nos.join(", ");
                const baseObj = {
                    station: item.station,
                    handler_org_id: item.handler_org_id,
                    slots: item.slots,
                    id: item.id,
                    handler_name: item.handler_name,
                    warehouse_id: null,
                    date: item.planned_date_time,
                    availableSlots: { ...EMPTY_AVAILABLE_SLOTS },
                    truckNos,
                };

                if (item.shipping_type === "L") loadingArr.push(baseObj);
                if (item.shipping_type === "U") unloadingArr.push(baseObj);

                setHandlerOptionsByLocation(prev => ({
                    ...prev,
                    [index]: fetchHandler(item.station),
                }));

                const truckData = (item.truck_data || []).map((td, i) => ({
                    id: Date.now() + i,
                    flight_prefix: td.truck.code,
                    flight_no: td.truck.number,
                    truck_date: td.truck_date?.split("T")[0],
                    intact_loose: "",
                    loading_sequence: i + 1,
                }));

                addTodData.push({
                    staion_name: item.station,
                    staion_id: item.station,
                    handler_name: item.handler_name || "",
                    handler_id: item.warehouse_id || "",
                    handler_org_id: item.handler_org_id,
                    slots: item.slots,
                    trip_status: item.shipping_type,
                    sequences: truckData,
                });
            });

            setSbFormData({ loading: loadingArr, unloading: unloadingArr });
            setTodFormData(addTodData);
            setOrderDetailsModal(false);
        } catch (error) {
            console.error('Error fetching order data:', error);
        }
    };

    const handleSubmit = async () => {
        const order_ids = (gridSelectData || []).map(o => o.id);
        const allItems = [
            ...(sbFormData.loading || []),
            ...(sbFormData.unloading || [])
        ];
        const invalidDate = allItems.find(item => !item.date);
        if (invalidDate) {
            toast.error(`Planning date time is required for station: ${invalidDate.handler_name}`);
            return;
        }
        const invalidSlots = allItems.find(
            item => item.availableSlots?.code === 400
        );
        if (invalidSlots) {
            toast.error(`Select date time within range for station: ${invalidSlots.handler_name}`);
            return;
        }
        const invalidItem = allItems.find(item => {
            const slots = item.availableSlots || {};
            const hasSlots =
                (Array.isArray(slots.past) && slots.past.length > 0) ||
                (slots.present !== null && slots.present !== undefined) ||
                (Array.isArray(slots.future) && slots.future.length > 0);
            if (hasSlots) {
                return !item.slot;
            }
            return false;
        });
        if (invalidItem) {
            toast.error(`Slot is required for station: ${invalidItem.handler_name}`);
            return;
        }
        const mapSlotItems = (items, shippingType) =>
            items.map(item => {
                const d = new Date(item.date);
                return {
                    shipping_type: shippingType,
                    station: item.station,
                    station_id: getDestination.find(s => s.label === item.station)?.port_Id || null,
                    handler_org_id: item.handler_org_id,
                    handler_name: item.handler_name,
                    planned_date_time: item.date,
                    date: d.toISOString().split("T")[0],
                    time: d.toTimeString().slice(0, 8),
                    warehouse_id: item.warehouse_id,
                    id: item.id ?? null,
                    slot: item.slot || null,
                    sequences: item.sequences || null,
                };
            });

        const payload = {
            trip_details: {
                trip_status: tdFormData.trip_status,
                vehicle_type: "Truck",
                side_loading: tdFormData.side_loading,
                truck_license_plate: tdFormData.truck_license_plate,
                trailer_license_plate: tdFormData.trailer_license_plate ?? "",
                driver1_first_name: tdFormData.driver1_first_name,
                driver1_last_name: tdFormData.driver1_last_name,
                driver2_first_name: tdFormData.driver2_first_name ?? "",
                driver2_last_name: tdFormData.driver2_last_name ?? "",
            },
            order_ids,
            slot_booking: [
                ...mapSlotItems(sbFormData.loading || [], "L"),
                ...mapSlotItems(sbFormData.unloading || [], "U"),
            ],
            truck_order_details: todFormData,
            trip_id: tripEditData.trip_id ?? null,
            deleted_id: deletedTodIds
        };
        try {
            const res = await withRFSToken.post('trip-management/save-trip', payload);

            if (res.data.response_code === 200) {
                setShowModalRequestSlot(false);
                onClose();
                toast.success(res.data.response_msg);
                setTimeout(onSuccess, 200);
            } else {
                toast.error(res.data.response_msg);
            }

        } catch (error) {
            console.error('Error saving trip:', error);
        }
    };

    // const handleSubmit = async () => {
    //     const order_ids = (gridSelectData || []).map(o => o.id);
    //     let slotErrorShown = true;
    //     const mapSlotItems = (items, shippingType) =>
    //         items.map(item => {
    //             const d = new Date(item.date);
    //             if (!item.slot) {
    //                 if (slotErrorShown) {
    //                     toast.error(`Slot is required for station: ${item.handler_name}`);
    //                     slotErrorShown = false;
    //                     return false;
    //                 }
    //                 return false;
    //             }
    //             return {
    //                 shipping_type: shippingType,
    //                 station: item.station,
    //                 station_id: getDestination.find(s => s.label === item.station)?.port_Id || null,
    //                 handler_org_id: item.handler_org_id,
    //                 handler_name: item.handler_name,
    //                 planned_date_time: item.date,
    //                 date: d.toISOString().split("T")[0],
    //                 time: d.toTimeString().slice(0, 8),
    //                 warehouse_id: item.warehouse_id,
    //                 id: item.id ?? null,
    //                 slot: item.slot || null,
    //                 sequences: item.sequences || null,
    //             };
    //         });
    //     const payload = {
    //         trip_details: {
    //             trip_status: tdFormData.trip_status,
    //             vehicle_type: "Truck",
    //             side_loading: tdFormData.side_loading,
    //             truck_license_plate: tdFormData.truck_license_plate,
    //             trailer_license_plate: tdFormData.trailer_license_plate ?? "",
    //             driver1_first_name: tdFormData.driver1_first_name,
    //             driver1_last_name: tdFormData.driver1_last_name,
    //             driver2_first_name: tdFormData.driver2_first_name ?? "",
    //             driver2_last_name: tdFormData.driver2_last_name ?? "",
    //         },
    //         order_ids,
    //         slot_booking: [
    //             ...mapSlotItems(sbFormData.loading || [], "L"),
    //             ...mapSlotItems(sbFormData.unloading || [], "U"),
    //         ],
    //         truck_order_details: todFormData,
    //         trip_id: tripEditData.trip_id ?? null,
    //     };
    //     try {
    //         const res = await withRFSToken.post('trip-management/save-trip', payload);
    //         if (res.data.response_code === 200) {
    //             setShowModalRequestSlot(false);
    //             toast.success(res.data.response_msg);
    //             setTimeout(onSuccess, 200);
    //         } else {
    //             toast.error(res.data.response_msg);
    //         }
    //     } catch (error) {
    //         console.error('Error saving trip:', error);
    //     }
    // };

    /* ── Validation ──────────────────────────────────────────────────────────── */

    const validateTdStep = (fields) =>
        fields.every(field => tdFormData[field]?.toString().trim() !== '');

    const validateTodStep = () => {
        for (let locIndex = 0; locIndex < todFormData.length; locIndex++) {
            const loc = todFormData[locIndex];
            if (!loc.staion_name) { toast.error(`Station Code is mandatory (Location ${locIndex + 1})`); return false; }
            if (!loc.handler_name) { toast.error(`Handler Name is mandatory (Location ${locIndex + 1})`); return false; }
            if (!loc.trip_status) { toast.error(`Please select Loading or Unloading (Location ${locIndex + 1})`); return false; }

            for (let seqIndex = 0; seqIndex < (loc.sequences || []).length; seqIndex++) {
                const seq = loc.sequences[seqIndex];
                if (!seq.flight_prefix || !seq.flight_no) {
                    toast.error(`Truck Number is mandatory (Location ${locIndex + 1}, Sequence ${seqIndex + 1})`);
                    return false;
                }
                if (!seq.truck_date) {
                    toast.error(`Truck Date is mandatory (Location ${locIndex + 1}, Sequence ${seqIndex + 1})`);
                    return false;
                }
                if (!seq.intact_loose) {
                    toast.error(`Please select Intact or Loose (Location ${locIndex + 1}, Sequence ${seqIndex + 1})`);
                    return false;
                }
            }
        }
        return true;
    };

    const compareInitialWithCurrent = () => {
        if (!initialFormData?.todFormData) return 1;
        const normalize = (data) => data.map(item => ({
            staion_name: item.staion_name || "",
            staion_id: item.staion_id || "",
            handler_name: item.handler_name || "",
            handler_id: item.handler_id || null,
            handler_org_id: item.handler_org_id || null,
            trip_status: item.trip_status || "",
            sequences: (item.sequences || []).map(seq => ({
                flight_prefix: seq.flight_prefix || "",
                flight_no: seq.flight_no || "",
                truck_date: seq.truck_date || "",
                intact_loose: seq.intact_loose || "",
                loading_sequence: seq.loading_sequence || null,
            })),
        }));
        return JSON.stringify(normalize(todFormData)) === JSON.stringify(normalize(initialFormData.todFormData)) ? 0 : 1;
    };

    /* ── Grid helpers ────────────────────────────────────────────────────────── */

    const getHandlersByStation = (stationCode, handlerOrgId) => {
        // console.log("getHandlersByStation", getDestination)
        const station = getDestination.find(s => s.label === stationCode);
        if (!station?.station_users) return [];
        return station.station_users
            .filter(user => user.org_id === handlerOrgId)
            .flatMap(user =>
                (user.warehouses || []).map(warehouse => ({
                    value: warehouse.id,
                    label: warehouse.name,
                    org_id: user.org_id,
                    warehouse_id: warehouse.id,
                    station_user_id: user.id,
                }))
            );
    };

    const fetchHandler = (stationCode) => {
        try {
            const station = getDestination.find(s => s.value === stationCode);
            if (!station?.station_users) return [];
            return station.station_users.flatMap(user =>
                (user.warehouses || []).map(warehouse => ({
                    value: warehouse.id,
                    label: warehouse.name,
                    org_id: user.org_id,
                    warehouse_id: warehouse.id,
                    handler_org_id: user.handler_org_id,
                    station_user_id: user.id,
                }))
            );
        } catch (error) {
            console.error("Error fetching handler data:", error);
            return [];
        }
    };

    const handleSlotClick = (type, index, slotType, slot, setSbFormDataFn) => {
        setSbFormDataFn(prev => {
            const updated = [...prev[type]];
            updated[index] = {
                ...updated[index],
                selected_slot_type: slotType,
                selected_slot_key: `${slot.door_id}_${slot.start_time}`,
                slot,
            };
            return { ...prev, [type]: updated };
        });
    };

    const refreshGrid = () => {
        const grid = window.$(gridRefs.current);
        grid.jqxGrid('updatebounddata');
        grid.jqxGrid('refresh');
    };

    const loadGrid = () => {
        if (!gridRefs.current) return;
        const token = 'Bearer ' + localStorage.Trucking;
        const source = {
            datatype: 'json',
            url: `${process.env.REACT_APP_RFS_URL}order-view-list`,
            root: 'Rows',
            cache: false,
            datafields: [
                { name: 'id', type: 'number' },
                { name: 'order_no', type: 'string' },
                { name: 'truck_no', type: 'string' },
                { name: 'truck_date', type: 'string' },
            ],
            beforeSend: (jqXHR) => jqXHR.setRequestHeader('Authorization', token),
            filter: () => {
                window.$(gridRefs.current).jqxGrid('clearselection');
                window.$(gridRefs.current).jqxGrid("updatebounddata", "filter");
            },
            beforeprocessing: (data) => {
                if (data?.Rows) source.totalrecords = data.TotalRows;
            },
        };

        const dataAdapter = new window.$.jqx.dataAdapter(source);
        const columns = [
            { text: 'Order No', datafield: 'order_no', width: '33%' },
            { text: 'Truck No', datafield: 'truck_no', width: '33%' },
            {
                text: 'Truck Date', datafield: 'truck_date', width: '33%',
                cellsrenderer: (rowIndex, dataField, cellValue) => {
                    if (!cellValue) return '';
                    return `<div style="margin-top:8px;">${new Date(cellValue).toISOString().split('T')[0]}</div>`;
                },
            },
        ];

        window.$(gridRefs.current).jqxGrid({
            width: '100%',
            source: dataAdapter,
            columns,
            autoheight: false,
            height: 800,
            sortable: true,
            altrows: false,
            enabletooltips: true,
            editable: false,
            pagesizeoptions: ['20', '100', '200', '500'],
            pageable: true,
            pageSize: 20,
            pagerButtonsCount: 5,
            pagerMode: 'advanced',
            filterable: true,
            filterrowheight: 45,
            selectionmode: 'checkbox',
            showfilterrow: true,
            rowsheight: 42,
            columnsheight: 45,
            virtualmode: true,
            rendergridrows: (params) => params.data,
        });

        window.$(gridRefs.current).on('rowselect', (event) => {
            const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', event.args.rowindex);
            setGridSelectData(prev =>
                prev.some(row => row.id === rowData.id) ? prev : [...prev, rowData]
            );
        });

        window.$(gridRefs.current).on('rowunselect', (event) => {
            const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', event.args.rowindex);
            setGridSelectData(prev => prev.filter(row => row.id !== rowData.id));
        });

        window.$(gridRefs.current).on('bindingcomplete', syncGridSelection);
    };

    const uncheckGridRowById = (id) => {
        const rows = window.$(gridRefs.current).jqxGrid('getrows');
        const rowIndex = rows.findIndex(r => r.id === id);
        if (rowIndex !== -1) window.$(gridRefs.current).jqxGrid('unselectrow', rowIndex);
    };

    const syncGridSelection = () => {
        if (!gridRefs.current || !gridSelectData.length) return;
        const rows = window.$(gridRefs.current).jqxGrid('getrows');
        gridSelectData.forEach(selected => {
            const rowIndex = rows.findIndex(r => r.id === selected.id);
            if (rowIndex !== -1) window.$(gridRefs.current).jqxGrid('selectrow', rowIndex);
        });
    };

    /* ── Step navigation ─────────────────────────────────────────────────────── */

    // const handleStepClick = (stepId) => {
    //     if (stepId === 2 && !validateTdStep(TD_REQUIRED_FIELDS)) {
    //         toast.error('Please fill all mandatory fields before proceeding.');
    //         return;
    //     }
    //     if (activeStep === 2 && stepId !== 1 && !validateTodStep()) return;
    //     setActiveStep(stepId);
    // };

    const handleStepClick = (stepId) => {
        if (stepId > activeStep) {
            if (activeStep === 0 && !validateTdStep(TD_REQUIRED_FIELDS)) {
                toast.error('Please fill all mandatory fields before proceeding.');
                return;
            }
            if (activeStep === 1 && !validateTodStep()) {
                return;
            }
        }
        setActiveStep(stepId);
    };

    const goPrevious = () => { if (activeStep > 0) setActiveStep(activeStep - 1); };

    const goNext = () => {
        if (!validateTdStep(TD_REQUIRED_FIELDS)) {
            toast.error('Please fill all mandatory fields before proceeding.');
            return;
        }
        if (activeStep === 1 && !validateTodStep()) return;
        if (activeStep < steps.length) setActiveStep(activeStep + 1);
    };

    /* ── StationLoop sub-component ───────────────────────────────────────────── */

    const StationLoop = ({ type, data, setSbFormData }) => {
        useEffect(() => {
            data.forEach((item, index) => {
                const hasValidInputs = item.date && item.warehouse_id && item.handler_org_id;
                const slots = item.availableSlots;
                const slotsNotLoaded =
                    !slots ||
                    (slots.past?.length === 0 && !slots.present && slots.future?.length === 0 && !slots.message);

                if (hasValidInputs && slotsNotLoaded && mode === "create") {
                    availableSlot(item.date, item.warehouse_id, type, index, setSbFormData);
                }

                if (slots?.present?.door_id && !item.selected_slot_key) {
                    setSbFormData(prev => {
                        const updated = [...prev[type]];
                        updated[index] = {
                            ...updated[index],
                            selected_slot_type: 'present',
                            selected_slot_key: `${slots.present.door_id}_${slots.present.start_time}`,
                            slot: slots.present,
                            sequences: item.sequences,
                        };
                        return { ...prev, [type]: updated };
                    });
                } else if (
                    item.selected_slot_key &&
                    item.selected_slot_type === 'present' &&
                    !slots?.present?.door_id
                ) {
                    setSbFormData(prev => {
                        const updated = [...prev[type]];
                        updated[index] = {
                            ...updated[index],
                            selected_slot_type: null,
                            selected_slot_key: null,
                            slot: null,
                            sequences: item.sequences,
                        };
                        return { ...prev, [type]: updated };
                    });
                }
            });
        }, [data, type, setSbFormData]);

        return (
            <>
                {data.map((item, index) => {
                    const slots = item.availableSlots || { ...EMPTY_AVAILABLE_SLOTS };
                    const handlerOptions = getHandlersByStation(item.station, item.handler_org_id);
                    const stationUser = getDestination.find(o => o.label === item.station);
                    const selectedHandler = handlerOptions.find(o => o.value === item.warehouse_id);
                    const warehouseMetaLabels =
                        getDestination
                            .find(o => o.label === item.station)
                            ?.station_users
                            .find(su =>
                                su.id === selectedHandler.station_user_id &&
                                su.org_id === selectedHandler.org_id
                            )
                            ?.warehouses
                            .find(wh => wh.id === selectedHandler.warehouse_id)
                            ?.warehouse_meta_lables || [];

                    const startTime = warehouseMetaLabels.find(m => m.trucking_metalabel_id == 18)?.value || null;
                    const endTime = warehouseMetaLabels.find(m => m.trucking_metalabel_id == 204)?.value || null;

                    const formatDateTimeLocal = (date) => {
                        const pad = (n) => String(n).padStart(2, "0");

                        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
                    };

                    const now = new Date();

                    const minDate = startTime
                        ? new Date(now.getTime() + startTime * 60 * 60 * 1000)
                        : null;

                    const maxDate = endTime
                        ? new Date(now.getTime() + endTime * 60 * 60 * 1000)
                        : null;
                    const minDateTime = minDate ? formatDateTimeLocal(minDate) : undefined;
                    const maxDateTime = maxDate ? formatDateTimeLocal(maxDate) : undefined;
                    return (
                        <div className={`${type}Loop Loop`} key={`${type}-${index}`}>
                            <div className='truck_no'>
                                <h4>Truck No : {item.truckNos}</h4>
                            </div>
                            <div className="px-2">
                                <Form.Group as={Row} className="mb-1">
                                    <Col sm="6">
                                        {item.handler_org_id ? (
                                            <>
                                                <label className="form-label">Station Code <span className='red'>*</span></label>
                                                <Select
                                                    classNamePrefix="rs"
                                                    options={getDestination}
                                                    value={getDestination.find(o => o.label === item.station)}
                                                    onChange={(selected) => {
                                                        setSbFormData(prev => {
                                                            const updated = [...prev[type]];
                                                            updated[index] = {
                                                                ...updated[index],
                                                                station: selected.label,
                                                                station_id: selected.port_Id,
                                                                handler_org_id: null,
                                                                handler_name: "",
                                                                warehouse_id: null,
                                                                availableSlots: { ...EMPTY_AVAILABLE_SLOTS },
                                                            };
                                                            return { ...prev, [type]: updated };
                                                        });
                                                    }}
                                                    isDisabled="true"
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <label className="form-label">Station Code</label>
                                                <div className="form-control bg-light">{item.station || "—"}</div>
                                            </>
                                        )}
                                    </Col>
                                    <Col sm="6">
                                        {item.handler_org_id ? (
                                            handlerOptions.length > 0 ? (
                                                <>
                                                    <label className="form-label">Handler Name <span className='red'>*</span></label>
                                                    <Select
                                                        classNamePrefix="rs"
                                                        options={handlerOptions}
                                                        value={handlerOptions.find(o => o.value === item.warehouse_id)}
                                                        onChange={(selected) => {
                                                            setSbFormData(prev => {
                                                                const updated = [...prev[type]];
                                                                updated[index] = {
                                                                    ...updated[index],
                                                                    warehouse_id: selected.warehouse_id,
                                                                    selected_slot_type: null,
                                                                    selected_slot_key: null,
                                                                    slot: null,
                                                                    availableSlots: { ...EMPTY_AVAILABLE_SLOTS },
                                                                };
                                                                return { ...prev, [type]: updated };
                                                            });
                                                            if (item.date) {
                                                                availableSlot(item.date, selected.warehouse_id, type, index, setSbFormData);
                                                            }
                                                        }}
                                                        isDisabled="true"
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    <label className="form-label">Handler Name</label>
                                                    <div className="form-control bg-light">{item.handler_name || "—"}</div>
                                                </>
                                            )
                                        ) : (
                                            <>
                                                <label className="form-label">Handler Name</label>
                                                <div className="form-control bg-light">{item.handler_name || "—"}</div>
                                            </>
                                        )}
                                    </Col>
                                </Form.Group>
                            </div>
                            <div className="rounded charter_top h-90 px-1 bookig_slot">
                                <div className="calendar-container">
                                    <Form.Group as={Row} className="mb-2">
                                        <Col sm="12">
                                            <label className='form-label'>Planned Date / Time { }</label>
                                            <input
                                                type="datetime-local"
                                                className="form-control"
                                                value={item.date || ""}
                                                min={minDateTime}
                                                max={maxDateTime}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setSbFormData(prev => {
                                                        const updated = [...prev[type]];
                                                        updated[index] = {
                                                            ...updated[index],
                                                            date: value,
                                                            selected_slot_type: null,
                                                            selected_slot_key: null,
                                                            slot: null,
                                                            availableSlots: { ...EMPTY_AVAILABLE_SLOTS },
                                                        };
                                                        return { ...prev, [type]: updated };
                                                    });
                                                    if (item.warehouse_id) {
                                                        availableSlot(value, item.warehouse_id, type, index, setSbFormData);
                                                    }
                                                }}
                                            />
                                        </Col>
                                    </Form.Group>
                                    <div className="">
                                        {item?.planned_date_time && (
                                            <div className="available_time_selected">
                                                <span>{item.planned_date_time.split(' ')[0]}</span> {' '}
                                                <span>{item.request_booking_slot}</span>
                                            </div>
                                        )}
                                    </div>

                                    {slots.message && (
                                        <p className={
                                            slots.code === 400 ? 'text-danger notavailable_tym' :
                                                slots.code === 405 ? 'text-inactive' : ''
                                        }>
                                            {slots.code === 400 ? <img src={red_x} className='red_x' alt="red_x" /> : null}
                                            <span>{slots.message}</span>
                                        </p>
                                    )}

                                    {(!item.handler_org_id || (item.handler_org_id && handlerOptions.length === 0)) && (
                                        <p className='text-inactive'>Door planning not applied, arrival reference only.</p>
                                    )}



                                    {!slots.present?.door_id && (slots.past.length > 0 || slots.future.length > 0) && (
                                        <p className="notavailable_tym">
                                            <img src={red_x} className='red_x' alt="red_x" />
                                            <span>No timeslot available at the selected time. Please select an open option below.</span>
                                        </p>
                                    )}

                                    {slots.present?.door_id && (
                                        <h4
                                            className='avl_time'
                                            onClick={() => handleSlotClick(type, index, 'present', slots.present, setSbFormData)}
                                        >
                                            <span><img src={green_check} alt='green_check' /></span>
                                            Timeslot Available{' '}
                                            <span className='ps-2'>
                                                {formatTime(slots.present.start_time)} - {formatTime(slots.present.end_time)}
                                            </span>
                                        </h4>
                                    )}

                                    {!slots.present?.door_id && (
                                        <>
                                            {slots.past.length > 0 && (
                                                <h1 className='available_time_nearby'>Available Times Nearby</h1>
                                            )}
                                            {slots.past.length > 0 && (
                                                <div className="avalable">
                                                    <h2 className='textMuted'>Earlier</h2>
                                                    <div className="row slotavltym">
                                                        {slots.past.map((slot, i) => (
                                                            <div
                                                                key={i}
                                                                className={`${isSelectedSlot(item, 'past', slot) ? 'available_tym' : ''} col-md-6 mb-2`}
                                                                onClick={() => handleSlotClick(type, index, 'past', slot, setSbFormData)}
                                                            >
                                                                <span>{slot.start_time}</span>
                                                                {/* <span>{slot.end_time}</span> */}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                            {slots.future.length > 0 && (
                                                <div className="avalable">
                                                    <h2 className='textMuted'>Later</h2>
                                                    <div className="row slotavltym">
                                                        {slots.future.map((slot, i) => (
                                                            <div
                                                                key={i}
                                                                className={`${isSelectedSlot(item, 'future', slot) ? 'available_tym' : ''} col-md-6 mb-2`}
                                                                onClick={() => handleSlotClick(type, index, 'future', slot, setSbFormData)}
                                                            >
                                                                <span>{slot.start_time}</span>
                                                                {/* <span>{slot.end_time}</span> */}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </>
        );
    };

    /* ── Render ──────────────────────────────────────────────────────────────── */


    // const validateTruck = (locationIndex, seqIndex) => {
    //     const seq = todFormData[locationIndex].sequences[seqIndex];
    //     if (!seq.flight_prefix || !seq.flight_no || !seq.truck_date) {
    //         //toast.error("Truck Number and Date are required");
    //         return false;
    //     }
    //     CallApi({
    //         endPoint: "trip-management/truck-trip-details",
    //         payload: { truck_no: seq.flight_prefix, truck_date: seq.truck_date, flight_prefix: seq.flight_no },
    //         onSuccess: (res) => {
    //             // const innerData = res.data.response_data;
    //             // toast.success(res.data.response_msg);
    //             // onReload()
    //         },
    //         onError: (msg) => toast.error(msg)
    //     });
    //     return true;
    // };
    const validateTruck = (locationIndex, seqIndex) => {
        const seq = todFormData[locationIndex].sequences[seqIndex];
        if (!seq.flight_prefix || !seq.flight_no || !seq.truck_date) {
            return false;
        }
        CallApi({
            endPoint: "trip-management/truck-trip-details",
            payload: { truck_no: seq.flight_no, truck_date: seq.truck_date, flight_prefix: seq.flight_prefix },
            onSuccess: (res) => {
                if (res.data.response_data.length > 0) {
                    setTodFormData(prev => {
                        const updated = [...prev];
                        updated[locationIndex] = {
                            ...updated[locationIndex],
                            sequences: updated[locationIndex].sequences.map((item, index) => {
                                if (index === seqIndex) {
                                    return {
                                        ...item,
                                        // flight_prefix: "",
                                        // flight_no: "",
                                        truck_date: ""
                                    };
                                }
                                return item;
                            })
                        };
                        return updated;
                    });
                    toast.error("Trip already present for this truck number and date");
                }
            },
            onError: (msg) => toast.error(msg)
        });
        return true;
    };

    const currentStep = steps[activeStep];



    return (
        <>
            <CommonModal
                show={showModalRequestSlot}
                mSize='xl'
                onHide={() => {
                    setShowModalRequestSlot(false);
                    onClose();
                }}
                className='modal_bgw primary_modal TruckerTripModal'
            >
                <div className='d-flex justify-content-between'>
                    <div className="tw-20 recovery_step_dv">
                        <p>Create Recovery Case</p>
                        <Stepper activeStep={activeStep} orientation="vertical" className='recovery_step'>
                            {steps.map((step, index) => (
                                <Step
                                    key={step.id}
                                    disabled={index !== activeStep}
                                    className={activeStep === index ? 'stepActive' : ''}
                                >
                                    <StepLabel onClick={() => handleStepClick(step.id)}>
                                        {step.title}
                                    </StepLabel>
                                </Step>
                            ))}
                        </Stepper>


                    </div>
                    <div className="tw-80 recovery_details">
                        {activeStep === 1 && (
                            <Button onClick={() => setOrderDetailsModal(true)} className='mb-0 addtodBtn'>
                                <span className='d-flex align-items-center'>
                                    <FontAwesomeIcon icon={faPlus} className='ps-1' /> Add Existing Order
                                </span>
                            </Button>
                        )}

                        {/* ── Step 1: Trip Details ── */}
                        {activeStep === 0 && (
                            <>
                                <div className='title_Dv'>
                                    <h6>{currentStep?.title}</h6>
                                    <p>{currentStep?.sub_title}</p>
                                </div>
                                <div>
                                    <Row>
                                        <Col md={6}>

                                            <div className='driver_truck_details'>

                                                <Form.Group className="mb-2">
                                                    <label className="form-label">
                                                        Export / Import <span className='red'>*</span>
                                                        <span className='ps-1'>
                                                            <OverlayTrigger
                                                                show={showTooltip}
                                                                placement="right"
                                                                overlay={<Tooltip id="export-import-tooltip" />}
                                                            >
                                                                <span
                                                                    className="export_import_tooltip"
                                                                    style={{ display: "inline-block", cursor: "pointer" }}
                                                                    onMouseEnter={() => setShowTooltip(true)}
                                                                    onMouseLeave={() => setShowTooltip(false)}
                                                                >
                                                                    <img src={info} alt="Info" />
                                                                </span>
                                                            </OverlayTrigger>
                                                            {showTooltip && (
                                                                <div className='tooltip_contents'>
                                                                    <p className='mb-1'><b>Export / Import</b></p>
                                                                    <p>Select whether the trip concerns an Export or Import RFS movement.</p>
                                                                    <p className='mb-1'><b>**Export**</b></p>
                                                                    <p>Cargo is delivered to the handler for a connecting flight at the arrival location.</p>
                                                                    <p className='mb-1'><b>**Import**</b></p>
                                                                    <p>Means the cargo is collected from the handler after flight arrival and transported further by road to its final destination.</p>
                                                                </div>
                                                            )}
                                                        </span>
                                                    </label>
                                                    <div className='d-flex frmChk_dv'>
                                                        <Form.Check
                                                            type="radio" id="vehicle-truck" label="Export"
                                                            name="trip_status" value="Export"
                                                            checked={tdFormData.trip_status === "Export"}
                                                            onChange={() => handleChange("td", { target: { name: "trip_status", value: "Export" } })}
                                                            className='customFrmchk'
                                                        />
                                                        <Form.Check
                                                            type="radio" id="vehicle-van" label="Import"
                                                            name="trip_status" value="Import"
                                                            checked={tdFormData.trip_status === "Import"}
                                                            onChange={() => handleChange("td", { target: { name: "trip_status", value: "Import" } })}
                                                            className='customFrmchk'
                                                        />
                                                    </div>
                                                </Form.Group>

                                                <Form.Group className="mb-2">
                                                    <label className="form-label">Truck License Plate <span className='red'>*</span></label>
                                                    <Form.Control type="text" name="truck_license_plate" value={tdFormData.truck_license_plate} onChange={(e) => handleChange("td", e)} />
                                                </Form.Group>

                                                <Form.Group className="mb-2">
                                                    <label className="form-label">Trailer License Plate <span className='red'>*</span></label>
                                                    <Form.Control type="text" name="trailer_license_plate" value={tdFormData.trailer_license_plate} onChange={(e) => handleChange("td", e)} />
                                                </Form.Group>

                                                <Form.Group className="mb-2">
                                                    <Form.Label>Driver 1 First Name <span className='red'>*</span></Form.Label>
                                                    <Form.Control type="text" name="driver1_first_name" value={tdFormData.driver1_first_name} onChange={(e) => handleChange("td", e)} />
                                                </Form.Group>

                                                <Form.Group className="mb-2">
                                                    <Form.Label>Driver 1 Last Name <span className='red'>*</span></Form.Label>
                                                    <Form.Control type="text" name="driver1_last_name" value={tdFormData.driver1_last_name} onChange={(e) => handleChange("td", e)} />
                                                </Form.Group>

                                                <Link
                                                    to="#"
                                                    className="w-100 d-inline-block text-end pe-2 add_driver"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setDriver2(prev => {
                                                            const next = !prev;
                                                            if (!next) {
                                                                setTdFormData(prevData => ({
                                                                    ...prevData,
                                                                    driver2_first_name: '',
                                                                    driver2_last_name: '',
                                                                }));
                                                            }
                                                            return next;
                                                        });
                                                    }}
                                                >
                                                    <button>
                                                        {driver2 ? (
                                                            <><img src={remove_driver} alt="Remove" className="pe-2" width={25} />Remove Driver 2</>
                                                        ) : (
                                                            <><img src={add_driver} alt="Add" className="pe-2" width={25} />Add Driver 2</>
                                                        )}
                                                    </button>
                                                </Link>

                                                {driver2 && (
                                                    <>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Driver 2 First Name</Form.Label>
                                                            <Form.Control type="text" name="driver2_first_name" value={tdFormData.driver2_first_name} onChange={(e) => handleChange("td", e)} />
                                                        </Form.Group>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Driver 2 Last Name</Form.Label>
                                                            <Form.Control type="text" name="driver2_last_name" value={tdFormData.driver2_last_name} onChange={(e) => handleChange("td", e)} />
                                                        </Form.Group>
                                                    </>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={6} />
                                    </Row>
                                </div>
                            </>
                        )}

                        {/* ── Step 2: Truck Order Details ── */}
                        {activeStep === 1 && (
                            <>
                                <div className='title_Dv'>
                                    <h6>{currentStep?.title}</h6>
                                    <p>{currentStep?.sub_title}</p>
                                </div>
                                <div className='heightScroll'>
                                    {todFormData.map((location, locationIndex) => (
                                        <div className="trip_card" key={locationIndex}>
                                            <Row className="align-items-center mb-3">
                                                <Col md={6}>
                                                    <Row>
                                                        <Col sm="5" className='pe-0'>
                                                            <label className="form-label">Station Code <span className='red'>*</span></label>
                                                            <Select
                                                                options={getDestination}
                                                                placeholder="Station"
                                                                className="autoslct w-100"
                                                                value={getDestination.find(opt => opt.value === location.staion_id) || null}
                                                                onChange={(selected) => {
                                                                    updateLocationFields(locationIndex, {
                                                                        staion_name: selected.label,
                                                                        staion_id: selected.value,
                                                                        handler_name: "",
                                                                        handler_id: "",
                                                                    });
                                                                    setHandlerOptionsByLocation(prev => ({
                                                                        ...prev,
                                                                        [locationIndex]: fetchHandler(selected.value),
                                                                    }));
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col sm="7">
                                                            <label className="form-label">Handler Name <span className='red'>*</span></label>
                                                            {location?.staion_name === "AMS" ? (
                                                                (() => {
                                                                    const selectedHandlerIds = todFormData
                                                                        .filter((_, i) => i !== locationIndex)
                                                                        .map(loc => loc.handler_id)
                                                                        .filter(Boolean);

                                                                    const availableHandlers = (handlerOptionsByLocation[locationIndex] || [])
                                                                        .filter(opt => !selectedHandlerIds.includes(opt.value));

                                                                    return (
                                                                        <Select
                                                                            isDisabled={!location.staion_name}
                                                                            styles={{
                                                                                control: (base) => ({
                                                                                    ...base,
                                                                                    backgroundColor: !location.staion_name ? "#e9ecef" : base.backgroundColor,
                                                                                }),
                                                                            }}
                                                                            options={availableHandlers}
                                                                            placeholder="Handler Name"
                                                                            className="autoslct me-0 w-100"
                                                                            value={availableHandlers.find(o => o.value === location.handler_id) || null}
                                                                            onChange={(selected) => {
                                                                                updateLocationFields(locationIndex, {
                                                                                    handler_name: selected.label,
                                                                                    handler_id: selected.value,
                                                                                    handler_org_id: selected.handler_org_id,
                                                                                });
                                                                            }}
                                                                        />
                                                                    );
                                                                })()
                                                            ) : (
                                                                <input
                                                                    disabled={!location.staion_name}
                                                                    style={{ backgroundColor: !location.staion_name ? "#e9ecef" : undefined }}
                                                                    type="text"
                                                                    className="form-control w-100"
                                                                    placeholder="Enter Handler Name"
                                                                    value={location.handler_name || ""}
                                                                    onChange={(e) => {
                                                                        updateLocationFields(locationIndex, {
                                                                            handler_name: e.target.value,
                                                                            handler_id: "",
                                                                        });
                                                                    }}
                                                                />
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Col>

                                                <Col md={6}>
                                                    <Form.Label>Loading / Unloading <span className='red'>*</span></Form.Label>
                                                    <div className="d-flex lodng_unldng_dv frmChk_dv">
                                                        <Form.Check
                                                            type="radio" label="Loading"
                                                            name={`trip_status_${locationIndex}`}
                                                            className="mt-1 customFrmchk" id={`loadingus_${locationIndex}`}
                                                            checked={location.trip_status === "L"}
                                                            onChange={() => updateLocationField(locationIndex, "trip_status", "L")}
                                                        />
                                                        <Form.Check
                                                            type="radio" label="Unloading"
                                                            name={`trip_status_${locationIndex}`}
                                                            className="mt-1 customFrmchk" id={`unloading_${locationIndex}`}
                                                            checked={location.trip_status === "U"}
                                                            onChange={() => updateLocationField(locationIndex, "trip_status", "U")}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>

                                            {location.sequences.map((seq, seqIndex) => (
                                                <div className="trip_card_child" key={seq.id}>
                                                    <Row className="align-items-center">
                                                        <Col md={5}>
                                                            <Row>
                                                                <Col md={7} className='pe-0'>
                                                                    <Form.Label>Truck Number <span className='red'>*</span></Form.Label>
                                                                    <div className="d-flex mb-2 align-items-center">
                                                                        <Select
                                                                            options={getOwnerCodes}
                                                                            placeholder="Code"
                                                                            className="autoslct w-100 p-0 me-2"
                                                                            value={getOwnerCodes.find(opt => opt.value === seq.flight_prefix) || null}
                                                                            onChange={(selected) =>
                                                                                updateSequenceField(locationIndex, seqIndex, "flight_prefix", selected?.value || "")
                                                                            }
                                                                            onBlur={() => validateTruck(locationIndex, seqIndex)}
                                                                        />
                                                                        <Form.Control
                                                                            type="text" maxLength="8"
                                                                            value={seq.flight_no || ""}
                                                                            onChange={(e) =>
                                                                                updateSequenceField(locationIndex, seqIndex, "flight_no", e.target.value)
                                                                            }
                                                                            onBlur={() => validateTruck(locationIndex, seqIndex)}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md={5}>
                                                                    <Form.Label>Truck Date <span className='red'>*</span></Form.Label>
                                                                    <input
                                                                        type="date" className="form-control"
                                                                        value={seq.truck_date || ""}
                                                                        onChange={(e) =>
                                                                            updateSequenceField(locationIndex, seqIndex, "truck_date", e.target.value)
                                                                        }
                                                                        onBlur={() => validateTruck(locationIndex, seqIndex)}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Col>

                                                        <Col md={4} className='pt-1'>
                                                            <Form.Label>Loose / Intact <span className='red'>*</span></Form.Label>
                                                            <div className="d-flex intact_loose_dv frmChk_dv">
                                                                <Form.Check
                                                                    type="radio" label="Loose"
                                                                    name={`intact_loose_${locationIndex}_${seqIndex}`}
                                                                    id={`loose_${locationIndex}_${seqIndex}`}
                                                                    checked={seq.intact_loose === "Loose"}
                                                                    onChange={() => updateSequenceField(locationIndex, seqIndex, "intact_loose", "Loose")}
                                                                    className='customFrmchk'
                                                                />
                                                                <Form.Check
                                                                    type="radio" label="Intact"
                                                                    name={`intact_loose_${locationIndex}_${seqIndex}`}
                                                                    id={`intact_${locationIndex}_${seqIndex}`}
                                                                    checked={seq.intact_loose === "Intact"}
                                                                    onChange={() => updateSequenceField(locationIndex, seqIndex, "intact_loose", "Intact")}
                                                                    className='customFrmchk'
                                                                />
                                                            </div>
                                                        </Col>

                                                        {location.trip_status === "L" && (
                                                            <Col md={3} className="Loading_Sequence_dv">
                                                                <Form.Group>
                                                                    <Form.Label>Loading Sequence <span className='red'>*</span></Form.Label>
                                                                    <Form.Select
                                                                        value={seq.loading_sequence}
                                                                        onChange={(e) =>
                                                                            changeSequenceOrder(locationIndex, seqIndex, Number(e.target.value) - 1)
                                                                        }
                                                                    >
                                                                        {location.sequences.map((_, i) => (
                                                                            <option key={i} value={i + 1}>{i + 1}</option>
                                                                        ))}
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </Col>
                                                        )}

                                                        <Col md={12} className="text-end">
                                                            {location.sequences.length > 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="close_btn"
                                                                    onClick={() => removeSequence(locationIndex, seqIndex)}
                                                                >
                                                                    <FontAwesomeIcon icon={faXmark} />
                                                                </button>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            ))}

                                            <div className="pt-0">
                                                <Row>
                                                    <Col md={12} className="text-left">
                                                        <button type="button" className="add_btn" onClick={() => addSequence(locationIndex)}>
                                                            <FontAwesomeIcon icon={faPlus} /> Add truck order
                                                        </button>
                                                    </Col>
                                                </Row>
                                            </div>

                                            {todFormData.length > 1 && (
                                                <div className="pt-0">
                                                    <Row>
                                                        <Col md={12} className="text-end">
                                                            <button type="button" className="dlt_btn" onClick={() => deleteLocation(locationIndex, location.deleted_id)}>
                                                                <img src={trash} alt='trash' />
                                                            </button>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                    <div className="text-center mt-3">
                                        <button type="button" className='add_btn_active' onClick={addLocation}> <FontAwesomeIcon icon={faPlus} /> Add Location</button>
                                    </div>
                                </div>
                            </>
                        )}

                        {/* ── Step 3: Slot Booking ── */}
                        {activeStep === 2 && (
                            <>
                                <div className='title_Dv'>
                                    <h6>{currentStep?.title}</h6>
                                    <p>{currentStep?.sub_title}</p>
                                </div>
                                <div className='mt-3'>
                                    <Row>
                                        <Col sm="6" className='pe-0'>
                                            <div className="loading_dv">
                                                <h2>Loading Station</h2>
                                                <StationLoop type="loading" data={sbFormData.loading} setSbFormData={setSbFormData} />
                                            </div>
                                        </Col>
                                        <Col sm="6">
                                            <div className="unloading_dv">
                                                <h2>Unloading Station</h2>
                                                <StationLoop type="unloading" data={sbFormData.unloading} setSbFormData={setSbFormData} />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </>

                        )}

                        <div className='d-flex justify-content-between prev_nxt_btn'>
                            {activeStep === 0 ?
                                <div></div>
                                :
                                <Button variant="contained" className="prev_btn"
                                    disabled={activeStep === 0}
                                    style={{ visibility: activeStep === 0 ? "hidden" : "visible" }}
                                    onClick={goPrevious}
                                >
                                    <FontAwesomeIcon icon={faArrowLeft} /> Previous
                                </Button>
                            }
                            <Button className='trnext' variant="primary" onClick={activeStep === 2 ? handleSubmit : goNext}>

                                {activeStep === 2 ? <> Finalize</> : <> Next <FontAwesomeIcon icon={faArrowRight} /></>}
                            </Button>
                        </div>
                    </div>
                </div>
            </CommonModal>
            <Modal
                show={orderDetailsModal}
                onEntered={loadGrid}
                onHide={() => setOrderDetailsModal(false)}
                className='addfrom change_type truck_monitor_modal'
                centered size={'xl'} scrollable={true}
            >
                <Modal.Header closeButton />
                <Modal.Body>
                    <h3>Add Truck Order</h3>
                    <p>Please select any order in this list</p>
                    <Row>
                        <Col md={6}>
                            {!isLoadingod && <div ref={gridRefs} className="staion_grid" />}
                        </Col>
                        <Col md={6}>
                            <div className="oder_details driver_truck_details selected_order_list">
                                <h3>Selected Orders</h3>
                                {gridSelectData.map((order, index) => (
                                    <div className="order_details_list" key={order.id ?? index}>
                                        <div className="oder_no">
                                            <h6>Order No.</h6>
                                            <p>{order.order_no ?? '-'}</p>
                                        </div>
                                        <div className="truck_no">
                                            <h6>Truck No.</h6>
                                            <p>{order.truck_no ?? '-'}</p>
                                        </div>
                                        <div className="truck_no">
                                            <h6>Truck Date</h6>
                                            <p>{order.truck_date ? new Date(order.truck_date).toISOString().split('T')[0] : ''}</p>
                                        </div>
                                        <div className="dlt_icon" onClick={() => uncheckGridRowById(order.id)}>
                                            <img src={bin} alt="bin" />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-25 are_bottom">
                        <Button variant="primary" onClick={handleAddorder} className='me-3'>Add Order</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default TripEditModal;
